module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/yamaichi-jisho-e57f3d780e3d9cf1c97f16f7ffe9c7a7.png";